import React from 'react'
import Slider from 'rc-slider'
import { match } from 'ts-pattern'
import { Button } from 'antd'

import 'rc-slider/assets/index.css'
import { CssIcon } from '@/components/CssIcon'
import { figmaTheme } from '@/pages/tad.ai/_styles/figma-theme'


import { useState } from 'react';
import { cls } from 'tagged-classnames-free';
export interface IVolumeSliderProps {
  volume: number
  onChange?: (volume: number) => void
  className?: string
}

const VolumeSlider: React.FC<IVolumeSliderProps> = (props) => {
  const { volume, onChange, className } = props

  const value = Math.ceil(volume * 100)
  const muted = volume === 0
  const [isMounted, setIsMounted] = useState(false)

  // const previousVolume = usePrevious(volume, (prev, next) => {
  //   return prev !== next
  // })

  // rc-slider 内部使用了 useLayoutEffect 导致了 SSR 渲染时不断打印警告
  // const { isMounted } = useIsMounted()

  return (
    <div
      className={cls`relative inline-flex w-6 items-center justify-between gap-2 ${className}`}
    >
      <Button
        type='text'
        className='h-5 p-0'
        onClick={() => {
          // onChange?.(muted ? previousVolume || 1 : 0)
          setIsMounted(!isMounted)
        }}
      >
        <CssIcon
          className={`${muted ? 'i-cus--tad-volume-mute' : 'i-cus--tad-volume'} size-6`}
        />
      </Button>
      {match(isMounted)
        .with(true, () => {
          return (
            <div
              className='absolute ml-7 w-14 flex-1 py-2 md:w-20'
              onClick={(event) => {
                event.stopPropagation()
              }}
            >
              <Slider
                value={value}
                onChange={(value) => {
                  if (Array.isArray(value)) {
                    return
                  }
                  onChange?.(value / 100)
                }}
                handleRender={(_, props) => {
                  const { prefixCls, value } = props
                  return (
                    <div
                      className={cls`absolute -ml-1 mt-[-6px] h-[14px] !w-2 ${prefixCls} flex items-center justify-center`}
                      style={{
                        left: `${value}%`,
                      }}
                    >
                      <div
                        className={cls`h-[14px] w-[3px] rounded bg-[#dcdcdc]`}
                      />
                    </div>
                  )
                }}
                className={`mt-[2px]`}
                styles={{
                  rail: {
                    height: 2,
                    borderRadius: 2,
                  },
                  track: {
                    height: 2,
                    borderRadius: 2,
                    backgroundColor: figmaTheme.primary.dark,
                  },
                }}
              />
            </div>
          )
        })
        .otherwise(() => {
          return null
        })}
    </div>
  )
}

export default VolumeSlider
